import { render, staticRenderFns } from "./DetailReward.vue?vue&type=template&id=ea7f4558"
import script from "./DetailReward.vue?vue&type=script&lang=js"
export * from "./DetailReward.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports